<template>
  <div class="wrapper">
    <div class="animated fadeIn">
      <b-card header-tag="header" footer-tag="footer">
        <div slot="header">
          <h1>Liegenschaften - Übersicht</h1>
          <div class="card-header-actions"></div>
        </div>
        <b-card-body>
          <app-map></app-map>
          <hr class="separator" />
          <!-- NOTES: does not work with computed properties, only with methods (data); -->
          <!-- adding entries seems tricky, see below; maybe not so tricky after all :> -->
          <v-client-table
            v-if="getAssignedFacilityStatus"
            :columns="columns"
            :data="getAssignedFacilitiesOverview"
            :options="options"
            :theme="theme"
            id="dataTableFacilities"
            ref="facilityOverviewTable"
          >
            <!-- <div slot="settings" slot-scope="props">
              <b-dropdown variant="link" size="lg" no-caret>
                <template slot="button-content">
                  &#x2699;<span class="sr-only">Search</span>
                </template>

                <b-dropdown-item>Details/Bearbeiten</b-dropdown-item>
              </b-dropdown>
            </div> -->
          </v-client-table>
        </b-card-body>
      </b-card>
    </div>
  </div>
</template>

<script>
import Vue from "vue";
import { ClientTable, Event } from "vue-tables-2";
import { mapActions, mapGetters } from "vuex";

// Leaflet, OpenStreetMaps
import { LMap, LTileLayer, LMarker } from "vue2-leaflet";

import appMap from "../../Map";

Vue.use(ClientTable);

export default {
  name: "Facilities",
  methods: {
    ...mapActions([
      "loadMapFacilities",
      "loadAssignedFacilities",
      "loadPublicitygroups",
    ]),
    gotoRoute(id) {
      this.$router.push({
        // path: id + "/details"
        name: "Details",
        params: { facility: this.getFacilityById(id), id },
      });
    },
  },
  computed: {
    ...mapGetters([
      "getAssignedFacilityStatus",
      "getMapFacilityStatus",
      "getMapFacilities",
      "getAssignedFacilitiesOverview",
      // "getFacilityCoordinates",
      // "getFacilityId",
      // "getFacilityById",
      "getPublicitygroupStatus",
    ]),
  },
  components: {
    ClientTable,
    Event,
    appMap,
    LMap,
    LTileLayer,
    LMarker,
  },
  mounted: function () {
    if (!this.getMapFacilityStatus) {
      this.loadMapFacilities();
    }
    if (!this.getAssignedFacilityStatus) {
      this.loadAssignedFacilities();
    }
    // load businessgroups for details view
    if (!this.getPublicitygroupStatus) {
      this.loadPublicitygroups();
    }
  },
  data() {
    return {
      columns: [
        "location",
        "address",
        "country",
        "facilitynumberofapartments",
        "facilitynumberofmonitors",
        "facilitygroups",
        // "settings",
      ],
      options: {
        headings: {
          location: "Ort",
          address: "Adresse",
          country: "Land",
          facilitynumberofapartments: "Wohnungen",
          facilitynumberofmonitors: "Monitore",
          // settings: "Einstellungen",
        },
        sortable: [
          "location",
          "address",
          "country",
          "facilitynumberofapartments",
          "facilitynumberofmonitors",
        ],
        filterable: [
          "location",
          "address",
          "country",
          "facilitynumberofapartments",
          "facilitynumberofmonitors",
          "facilitygroups",
        ],
        sortIcon: {
          base: "fa",
          up: "fa-sort-asc",
          down: "fa-sort-desc",
          is: "fa-sort",
        },
        pagination: {
          chunk: 5,
          edge: false,
          nav: "scroll",
        },
        hiddenColumns: ["facilitygroups"],
        texts: {
          filter: "Filter",
          filterPlaceholder: "Filtern nach ...",
          columns: "Spalten",
          limit: "Einträge",
          count: "Zeige Liegenschaften {from} bis {to} von {count} Einträgen",
        },
      },
      useVuex: true,
      theme: "bootstrap4",
      template: "default",
      // leaflet / osm
      zoom: 13,
      center: L.latLng(47.259659, 11.400375),
      url: "http://{s}.tile.osm.org/{z}/{x}/{y}.png",
      attribution:
        '&copy; <a href="http://osm.org/copyright">OpenStreetMap</a> contributors',
    };
  },
};
</script>

<style scoped>
.separator {
  margin-top: 5%;
}
</style>
